var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconIos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.924,
    height: 32.791,
    viewBox: "0 0 27.924 32.791",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.7;}.b{fill:#208ce1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M28.03,7.12l.358-.536.351-.529.792-1.187A.317.317,0,1,0,29,4.517l-.848,1.272-.357.535-.362.542a10.618,10.618,0,0,0-7.551,0l-.36-.538-.357-.535L18.32,4.52a.317.317,0,1,0-.529.351l.791,1.187.353.529.358.536a7.212,7.212,0,0,0-4.516,6.343H32.548A7.212,7.212,0,0,0,28.03,7.12Zm-8.177,3.812A.952.952,0,1,1,20.8,9.98a.952.952,0,0,1-.951.952Zm7.614,0a.951.951,0,1,1,.674-.279.952.952,0,0,1-.674.279Z",
    transform: "translate(-9.699 -4.375)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.914,20.208h-.137V34.17a2.011,2.011,0,0,0,2.009,2.01h1.447a1.9,1.9,0,0,0-.076.529v4.02a1.9,1.9,0,0,0,3.808,0v-4.02a1.954,1.954,0,0,0-.075-.529h3.535a1.9,1.9,0,0,0-.075.529v4.02a1.9,1.9,0,0,0,3.807,0v-4.02a1.9,1.9,0,0,0-.075-.529h1.447a2.012,2.012,0,0,0,2.019-2.01V20.208Z",
    transform: "translate(-9.699 -9.843)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.925,20.208a1.9,1.9,0,0,0-1.9,1.9v8.144a1.9,1.9,0,0,0,3.807,0V22.112a1.9,1.9,0,0,0-1.9-1.9Z",
    transform: "translate(-7.021 -9.843)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M45.763,20.208a1.9,1.9,0,0,0-1.9,1.9v8.144a1.9,1.9,0,0,0,3.806,0V22.112a1.9,1.9,0,0,0-1.9-1.9Z",
    transform: "translate(-19.741 -9.843)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIos);
export default __webpack_public_path__ + "static/media/icon_ios.afca212599c165c03b594c4b49e74266.svg";
export { ForwardRef as ReactComponent };